export const getHighlitedDates = (
  productionTime: number | undefined | null
) => {
  const getNextBusinessDays = (
    count: number,
    startDate = new Date()
  ): Date[] => {
    const nextDate = new Date(startDate);
    nextDate.setDate(startDate.getDate() + 1);

    const isBusinessDay = (date: Date) => {
      const day = date.getDay();
      return day !== 0 && day !== 6;
    };

    if (count === 0) {
      return [];
    }

    return isBusinessDay(nextDate)
      ? [nextDate, ...getNextBusinessDays(count - 1, nextDate)]
      : getNextBusinessDays(count, nextDate);
  };

  return getNextBusinessDays(productionTime || 0);
};
